import React, { Component } from 'react';
import cx from 'classnames';

class Champion extends Component {
  render() {
    const image = `url(https://ddragon.leagueoflegends.com/cdn/${this.props.version}/img/sprite/${this.props.image.sprite})`;
    const position = `-${this.props.image.x}px -${this.props.image.y}px`;

    return (
      <div className={cx({'champion': true, 'unavailable': this.props.selected})} onClick={this.props.selected ? () => {} : this.props.onClick}>
        <div className="champion-icon" style={{backgroundImage: image, width: this.props.image.w, height: this.props.image.h, backgroundPosition: position}} />
        {this.props.name}
      </div>
    );
  }
}

export default Champion;



// WEBPACK FOOTER //
// ./src/Champion.js